<template>
  <div id="edit-item-order">
    <vs-popup title="Edit item" class="edit-item-popup" :active.sync="popupEditItem.isActive">
      <div class="p-2 flex align-center" style="height: 80px;">
        <!-- <vs-avatar v-if="itemData && itemData.item_image" class="border-2 border-solid border-grey con-vs-avatar m-0 text-6xl pick-avatar rounded-item item-image" size="55px" :src="itemData.item_image"></vs-avatar>
        <vs-avatar v-else class="border-2 border-solid border-grey con-vs-avatar m-0 text-6xl pick-avatar rounded-item item-image" size="55px" :src="default_image"></vs-avatar> -->

        <div v-if="itemData && itemData.item_image" class="rounded-item" style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                        :style="`background-image: url('${itemData.item_image}')`"></div>
        <div v-else class="rounded-item" style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
              :style="`background-image: url('${default_image}')`"></div>
        <div class="ml-3 item-title">
          <p class="font-extrabold text-lg item-name">{{itemData.item_name}}</p>
          <div class="text-grey-custom text-sm">
            <p>Price: ${{itemData.price}}</p>
          </div>
        </div>
      </div>
    <div style="height: calc(100% - 140px); overflow: hidden">
      <div class="overflow-auto h-full">
        <div class="p-2">
          <p class="font-bold text-lg">Select an option:</p>
          <div v-for="(vari, index) in itemVariant" :key="index" class="pt-2">
            <ul>
              <li>
                <!-- <vs-radio v-model="variant" :vs-value="`${vari.name}`" @click.native="getVariant(vari)" :key="radio_key">{{vari.name}}</vs-radio> -->
                <label class="vs-component con-vs-radio vs-radio-primary w-full">
                  <input name="variant" v-model="variant" type="radio" class="vs-radio--input" :id="vari.id" :value="vari" @click="getVariant(vari)" :key="radio_key">
                  <span class="vs-radio position-relative" :class="{'bg-primary': variant.name == vari.name}">
                      <span :class="{'vs-radio--borde': !(variant.name == vari.name)}"></span>
                      <span class="vs-radio--circle" style="position: relative;"></span>
                      <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px">check</i>
                  </span>
                  <span class="vs-radio--label flex align-center justify-between w-full">
                      <div class="content">{{vari.name}}</div>
                      <div>${{parseFloat(vari.price).toFixed(2)}}</div>
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div v-for="(mod, i) in itemModifier" :key="i">
          <div class="p-2" v-if="mod.is_selected && mod.details.length > 0">
            <p class="font-bold text-lg">{{mod.modifier_name}}</p>
            <div v-if="mod.type == 'multi'">
              <div v-for="(detail, index) in mod.details" :key="index" class="pt-2">
                <ul>
                  <li>
                    <!-- <vs-checkbox v-model="checkBox" :vs-value="`${detail.id}`" @click.native="getModifierMulti(detail)" :key="check_key">
                      <div>{{detail.name}}</div>
                      <div>${{parseFloat(detail.price).toFixed(2)}}</div>
                    </vs-checkbox> -->
                     <vs-checkbox :value="detail.selected" @click.native="getModifierMulti(detail, index, i)">
                      <div>{{detail.name}}</div>
                      <div>${{parseFloat(detail.price).toFixed(2)}}</div>
                    </vs-checkbox>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else>
              <div v-for="(detail, index) in mod.details" :key="index" class="pt-2">
                <ul>
                  <li>
                    <!-- <vs-radio :v-model="`${mod.value}`" :name="i + 'modifier' + mod.modifier_name" :id="`${detail.id}`" :vs-value="`${detail}`" @click.native="getModifierSingle(i , index)" :key="check_key">{{detail.name}}</vs-radio> -->
                    <label class="vs-component con-vs-radio vs-radio-primary w-full">
                        <input :name="i + 'modifier' + mod.modifier_name" v-model="mod.value" type="radio" class="vs-radio--input" :id="detail.id" :value="detail" @click="getModifierSingle(i , index)" :key="check_key">
                        <span class="vs-radio position-relative" :class="{'bg-primary': mod.value && mod.value.id == detail.id}">
                            <span :class="{'vs-radio--borde': !(mod.value && mod.value.id == detail.id)}"></span>
                            <span class="vs-radio--circle" style="position: relative;"></span>
                            <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px">check</i>
                        </span>
                        <span class="vs-radio--label flex align-center justify-between w-full">
                            <div class="content">{{detail.name}}</div>
                            <div>${{parseFloat(detail.price).toFixed(2)}}</div>
                        </span>
                    </label>
                    <input :name="i + 'modifier' + mod.modifier_name" v-model="mod.value" type="radio" class="vs-radio--input" :id="'modifier' + mod.modifier_name">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-2 w-full flex justify-between">
      <vs-input-number size="medium" v-model="quantity" :min="1" :max="50"/>
      <div v-if="quantity == 0">
        <vs-button @click="popupActive=true" color="danger">Remove</vs-button>
      </div>
      <div v-else>
        <vs-button @click="editItem">Submit</vs-button>
      </div>
    </div>
    </vs-popup>
    <vs-popup class="holamundo" title="Delete Item" :active.sync="popupActive">
      <div class="text-center">
        <h4>Give us a reason for your cancellation!</h4>
        <vs-textarea class="mt-4" v-model="cancel_reason" required></vs-textarea>
        <div class="flex flex-wrap justify-center align-center p-6">
          <vs-button class="mr-6 align-center" @click="deleteItem">Delete</vs-button>
          <vs-button
            type="border"
            color="danger"
            @click.stop="popupActive=false"
          >Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'edit-item-order',
  props:{
    popupEditItem:{
      type: Object
    },
    itemData:{
      type: Object
    },
    itemVariant:{
      type: Array
    },
    itemModifier:{
      type: Array
    }
  },
  data() {
    let variant = {};
    if(this.itemData && this.itemData.item_variant){
      variant = this.itemData.item_variant;
    }

    if(this.itemData && this.itemData.item_modifier){
      for(let i = 0; i < this.itemModifier.length;) {
        if(this.itemModifier[i].is_selected != true) {
          this.itemModifier.splice(i, 1);
        } else {
          i++;
        }
      }
      for(let i = 0;i<this.itemModifier.length;i++){
        if(this.itemModifier[i].type == 'single') {
          this.itemModifier[i] = this.initValueModifier(this.itemModifier[i], this.itemData.item_modifier);
        } else {
          for(let j = 0; j < this.itemModifier[i].details.length; j++) {
            this.itemModifier[i].details[j] = this.initStatusDetail(this.itemModifier[i], this.itemModifier[i].details[j], this.itemData.item_modifier);
          }
        }
      }
    }
    return {
      idModSingle: 1,
      default_image: 'https://www.mbrsg.ae/MBRSG/media/Images/no-image-icon-6.png',
      variant,
      quantity : this.itemData.quantity,
      item_variant: {},
      item_modifier: [],
      check_key: 0,
      radio_key :0,
      edit_key: 0,
      popupActive: false,
      cancel_reason : 'Out Of Stock!',
      quantity_key: 0
    }
  },
  watch:{
    popupEditItem:{
      immediate: true,
        deep: true,
        handler() {
          this.quantity = this.itemData.quantity;
          if(this.itemData && this.itemData.item_variant){
            this.variant = this.itemData.item_variant;
            this.quantity = this.itemData.quantity;
          }
          this.radio_key++;
        }
    },
    itemModifier: {
      immediate: true,
      deep: true,
      handler() {
        if(this.itemData && this.itemData.item_modifier){
          for(let i = 0; i < this.itemModifier.length;) {
            if(this.itemModifier[i].is_selected != true) {
              this.itemModifier.splice(i, 1);
            } else {
              i++;
            }
          }
          for(let i = 0;i<this.itemModifier.length;i++){
            if(this.itemModifier[i].type == 'single') {
              this.itemModifier[i] = this.initValueModifier(this.itemModifier[i], this.itemData.item_modifier);
            } else {
              for(let j = 0; j < this.itemModifier[i].details.length; j++) {
                this.itemModifier[i].details[j] = this.initStatusDetail(this.itemModifier[i], this.itemModifier[i].details[j], this.itemData.item_modifier);
              }
            }
          }
        }
      }
    },
  },
  methods:{
    deleteItem() {
      const obj = {
        order_id: this.itemData.order_id,
        id: this.itemData.id,
        cancel_reason : this.cancel_reason
      }
      this.$store.dispatch("order/CANCEL_ITEM" , obj).then(() => {
        this.$vs.notify({
          title:'Notification',
          text:'Delete Item Success',
          color:'success',
          position:'top-right'})
          this.popupActive = false;
          this.popupEditItem.isActive = false;
      }).catch((err) => {
        this.$vs.notify({
          title:'Notification',
          text: err.cancel_reason[0],
          color:'danger',
          position:'top-right'})
      })
    },
    initValueModifier(modifier, selected_list) {
      let modifier_temp = modifier;
      if(modifier_temp) {
        modifier_temp.value = null;
      }
      if(modifier && selected_list) {
        for(let i = 0; i < selected_list.length; i++) {
          if(selected_list[i].id == modifier.id && selected_list[i].details && selected_list[i].details[0]) {
            modifier_temp.value = selected_list[i].details[0];
            return modifier_temp;
          }
        }
      }
      return modifier_temp;
    },
    initStatusDetail(modifier, detail, selected_list) {
      let detail_temp = detail;
      if(detail_temp) {
        detail_temp.selected = false;
      }
      if(detail && modifier && selected_list) {
        for(let i = 0; i < selected_list.length; i++) {
          if(selected_list[i].id == modifier.id && selected_list[i].details) {
            for(let j = 0; j < selected_list[i].details.length; j++) {
              if(selected_list[i].details[j].id == detail.id) {
                detail_temp.selected = true;
                return detail_temp;
              }
            }
          }
        }
      }
      return detail_temp;
    },
    editItem(){
      for(let m = 0 ; m< this.itemVariant.length;m++){
        if(this.variant.name == this.itemVariant[m].name){
          this.item_variant.id = this.itemVariant[m].id;
          this.item_variant.price = this.itemVariant[m].price;
          this.item_variant.name = this.itemVariant[m].name;
        }
      }
      for(let i = 0; i<this.itemModifier.length;i++){
        const obj = {
          id: this.itemModifier[i].id,
          name : this.itemModifier[i].modifier_name,
          type : this.itemModifier[i].type,
          required : this.itemModifier[i].required,
          details: [],
        }
        this.item_modifier.push(obj);
        if(this.itemModifier[i].type == 'single'){
          if(this.itemModifier[i].value) {
              this.item_modifier[i].details = [];
              // this.itemModifier[i].value.price = parseFloat(this.itemModifier[i].value.price);
              this.item_modifier[i].details.push(this.itemModifier[i].value);
            }
        } else {
          for(let j = 0; j<this.itemModifier[i].details.length;) {
            if(this.itemModifier[i].details[j].selected != true) {
              this.itemModifier[i].details.splice(j, 1);
            } else {
              // this.itemModifier[i].details[j].price = parseFloat(this.itemModifier[i].details[j]);
              j++;
            }
            this.item_modifier[i].details = this.itemModifier[i].details;
          }
        }
        // for(let j = 0; j<this.itemModifier[i].details.length;j++){
        //   if(this.itemModifier[i].type == 'multi') {
        //     for(let k = 0 ; k< this.checkBox.length;k++){
        //       if(this.itemModifier[i].details[j].id == this.checkBox[k]){
        //         this.item_modifier[i].details.push(this.itemModifier[i].details[j])
        //       }
        //     }
        //   }
        // }
        let item_modifier_temp = JSON.parse(JSON.stringify(this.item_modifier));
        if(item_modifier_temp){
          for(let i = 0; i< item_modifier_temp.length;i++){
            for(let j = 0; j< item_modifier_temp[i].details.length;j++){
              // if(typeof(item_modifier_temp[i].details[j].price == 'string')){
                item_modifier_temp[i].details[j].price = parseFloat(item_modifier_temp[i].details[j].price)
              // }
            }
          }
        }
        this.item_modifier = item_modifier_temp;
      }
      const order_items =
        {
          id: this.itemData.id,
          item_id: this.itemData.item_id,
          quantity : this.quantity,
          item_name: this.itemData.item_name,
          item_variant: this.item_variant,
          item_modifier: this.item_modifier
        }
        // console.log(order_items);
      this.$emit("EditItem" , order_items)
    },
    getVariant(vari){
      this.item_variant.id = vari.id;
      this.item_variant.price = vari.price
      this.item_variant.name = vari.name
    },
    getModifierMulti(detail, detail_index, mod_index){
      // if(this.checkBox.length == 0){
      //   this.checkBox.push(detail.id)
      //   this.check_key++;
      // }else{
      //   for(let i = 0 ;i < this.checkBox.length; i++){
      //     if(this.checkBox[i] == detail.id){
      //       this.checkBox.splice(i, 1)
      //       this.check_key++;
      //       break;
      //     }
      //     if(i == this.checkBox.length) {
      //       this.checkBox.push(detail.id)
      //       this.check_key++;
      //     }
      //   }
      // }
      if(this.itemModifier[mod_index] && this.itemModifier[mod_index].details[detail_index]) {
        this.itemModifier[mod_index].details[detail_index].selected = !this.itemModifier[mod_index].details[detail_index].selected;
      }
      // console.log(this.itemModifier);
    },
    getModifierSingle(mod_id, detail_index){
      if(this.itemModifier[mod_id] && this.itemModifier[mod_id].details[detail_index]){
        this.itemModifier[mod_id].value = this.itemModifier[mod_id].details[detail_index];
      }
      this.check_key++;
    }
  }
}
</script>